import React from 'react';

const LteFddIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M6.84961 12.791H8.38477V10.166L8.26172 10.3652L6.84961 12.791Z'
				fill='#3984DB'
			/>
			<path
				d='M11.2787 20.7323V18.5543H11.5596C11.8056 18.5543 11.9929 18.6392 12.1214 18.809C12.2499 18.9788 12.3142 19.2311 12.3142 19.5659V19.7159C12.3142 20.0523 12.2499 20.3062 12.1214 20.4776C11.9929 20.6474 11.8088 20.7323 11.5692 20.7323H11.2787Z'
				fill='#3984DB'
			/>
			<path
				d='M14.4304 20.7323V18.5543H14.7112C14.9572 18.5543 15.1445 18.6392 15.273 18.809C15.4016 18.9788 15.4658 19.2311 15.4658 19.5659V19.7159C15.4658 20.0523 15.4016 20.3062 15.273 20.4776C15.1445 20.6474 14.9604 20.7323 14.7208 20.7323H14.4304Z'
				fill='#3984DB'
			/>
			<path
				clipRule='evenodd'
				d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM19.2012 15.0703C18.8848 15.4219 18.4219 15.7051 17.8125 15.9199C17.2031 16.1348 16.5352 16.2422 15.8086 16.2422C14.6914 16.2422 13.7988 15.9004 13.1309 15.2168C12.4629 14.5332 12.1055 13.582 12.0586 12.3633L12.0527 11.625C12.0527 10.7852 12.2012 10.0527 12.498 9.42773C12.7949 8.79883 13.2188 8.31641 13.7695 7.98047C14.3242 7.64062 14.9648 7.4707 15.6914 7.4707C16.7539 7.4707 17.5781 7.71484 18.1641 8.20312C18.7539 8.6875 19.0977 9.41211 19.1953 10.377H17.2148C17.1445 9.90039 16.9922 9.56055 16.7578 9.35742C16.5234 9.1543 16.1914 9.05273 15.7617 9.05273C15.2461 9.05273 14.8477 9.27148 14.5664 9.70898C14.2852 10.1465 14.1426 10.7715 14.1387 11.584V12.0996C14.1387 12.9512 14.2832 13.5918 14.5723 14.0215C14.8652 14.4473 15.3242 14.6602 15.9492 14.6602C16.4844 14.6602 16.8828 14.541 17.1445 14.3027V12.9785H15.7148V11.5664H19.2012V15.0703ZM10.3594 12.791H11.2266V14.3145H10.3594V16.125H8.38477V14.3145H5.08594L4.96875 13.1074L8.38477 7.61133V7.59375H10.3594V12.791ZM8.61273 19.9944H9.96002V19.3517H8.61273V18.5543H10.0957V17.9092H7.77722V21.375H8.61273V19.9944ZM10.4432 17.9092V21.375H11.5834C11.8834 21.3734 12.1547 21.302 12.3975 21.1608C12.6419 21.0179 12.8307 20.8212 12.9641 20.5704C13.0989 20.3181 13.1664 20.0333 13.1664 19.7159V19.5564C13.1648 19.2422 13.095 18.9589 12.9569 18.7066C12.8204 18.4527 12.63 18.2567 12.3856 18.1187C12.1412 17.979 11.8659 17.9092 11.5596 17.9092H10.4432ZM13.5948 17.9092V21.375H14.735C15.035 21.3734 15.3063 21.302 15.5491 21.1608C15.7935 21.0179 15.9824 20.8212 16.1157 20.5704C16.2505 20.3181 16.318 20.0333 16.318 19.7159V19.5564C16.3164 19.2422 16.2466 18.9589 16.1085 18.7066C15.972 18.4527 15.7816 18.2567 15.5372 18.1187C15.2928 17.979 15.0175 17.9092 14.7112 17.9092H13.5948Z'
				fill='#3984DB'
				fillRule='evenodd'
			/>
		</svg>
	);
};

export default LteFddIcon;
